import { render, staticRenderFns } from "./monthList.vue?vue&type=template&id=8b84c00a&scoped=true&"
import script from "./monthList.vue?vue&type=script&lang=js&"
export * from "./monthList.vue?vue&type=script&lang=js&"
import style0 from "./monthList.vue?vue&type=style&index=0&id=8b84c00a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b84c00a",
  null
  
)

export default component.exports